import moment from 'moment';

import { UserSettings } from '../../enums/user-settings/user-settings';
import Global from '../../store/global-selectors';

import { PrepaidDuty } from './constants';

export const filterDutiesOptions = (options) => options?.filter(({ additionalOptionEnum }) => additionalOptionEnum === PrepaidDuty) || [];

export const getUserSettingPrepayDutyAlert = (state) => {
  const settingValue = Global.selectUserUserSetting(state, {
    userSetting: UserSettings.prepayDutyAlert.settingName,
  });
  return settingValue !== undefined ? JSON.parse(settingValue) : settingValue;
};

export const createUserSettingPrepayDutyAlertFromSetting = (prepayDutyAlertSetting, { createdPrepayDutyOn, dismissedOn } = {}) => {
  return {
    settingName: UserSettings.prepayDutyAlert.settingName,
    settingValue: JSON.stringify({
      ...prepayDutyAlertSetting,
      ...((moment(createdPrepayDutyOn || null).isValid() || createdPrepayDutyOn === '') && { createdPrepayDutyOn }),
      ...((moment(dismissedOn || null).isValid() || dismissedOn === '') && {
        dismissedOn,
      }),
    }),
    excludeV3prefix: true,
  };
};

export const createUserSettingPrepayDutyAlert = (state, { createdPrepayDutyOn, dismissedOn } = {}) => {
  const prepayDutyAlert = getUserSettingPrepayDutyAlert(state);
  return {
    settingName: UserSettings.prepayDutyAlert.settingName,
    settingValue: JSON.stringify({
      ...prepayDutyAlert,
      ...((moment(createdPrepayDutyOn || null).isValid() || createdPrepayDutyOn === '') && { createdPrepayDutyOn }),
      ...((moment(dismissedOn || null).isValid() || dismissedOn === '') && {
        dismissedOn,
      }),
    }),
    excludeV3prefix: true,
  };
};

export const shouldShowPrepayDutyAlert = (state) => {
  const { createdPrepayDutyOn = '', dismissedOn = '' } = getUserSettingPrepayDutyAlert(state) || {};
  return !createdPrepayDutyOn && !dismissedOn;
};
